import React from "react";
import {TextField} from "@mui/material";
import {useTheme} from "../../../contexts/theme";


interface StyledTextareaProps {
    placeholder?: string;
    maxRows?: number;
    label?: string;
    paddingBottom?: string;
    value?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    width?: string;
    height?: string;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}


const StyledTextarea: React.FC<StyledTextareaProps> = ({
    placeholder,
    maxRows = 4,
    paddingBottom,
    value,
    onChange,
    label,
   width,
    onKeyDown = () => {},
   height}) => {

    const theme = useTheme();


    return(
        <TextField
            value={value}
            onChange={onChange}
            type='text'
            id="outlined-multiline-static"
            onKeyDown={onKeyDown}
            label={label}
            multiline
            rows={maxRows}
            placeholder={placeholder}
            sx={{
                width: width,
                height: height,
                paddingBottom: paddingBottom,
                '& .MuiInputBase-input': {
                    color: theme.palette.lightGrey,
                },
                '& .MuiInputLabel-root': {
                    color: theme.palette.lightGrey,
                    '&.Mui-focused': { // Colore della label in focus
                        color: theme.palette.orange,
                    },
                },
                '& .MuiFilledInput-root': {
                    '&:after': {
                        borderBottom: theme.palette.white, // Cambia il colore della linea
                    },
                    '&:hover:after': { // Colore della linea in hover
                        borderBottom: theme.palette.orange,
                    },
                    '&.Mui-focused:after': { // Colore della linea in focus
                        borderBottom: theme.palette.orange,
                    },
                },
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.white,
                },
                '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': { // Colore del bordo in hover
                        borderColor: theme.palette.orange,
                    },
                    '&.Mui-focused fieldset': { // Colore del bordo in focus
                        borderColor: theme.palette.orange,
                    },
                },
                '& .MuiOutlinedInput-input': {
                    color: theme.palette.lightGrey,
                },
            }}

        />
    );
};

export default StyledTextarea;